"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.oops = void 0;
var _settings = require("../../settings");
/* eslint-disable import/prefer-default-export */

var oops = exports.oops = function oops() {
  return {
    message: (0, _settings.getSettings)().oopsMessage || 'Oops!  Looks like you missed a step',
    messageType: 'Error'
  };
};
//# sourceMappingURL=common.js.map